import angular from 'angular';
import whatIsSolidaryEuroComponent from './whatIsSolidaryEuro.component';
import whatIsSolidaryList from './whatIsSolidaryList/whatIsSolidaryList';
import whatIsSolidaryCard from './whatIsSolidaryCard/whatIsSolidaryCard';
import whatIsSolidayEuroFooter from './whatIsSolidayEuroFooter/whatIsSolidayEuroFooter';

let whatIsSolidaryEuroModule = angular.module('whatIsSolidaryEuro', [
  whatIsSolidaryList,
  whatIsSolidaryCard,
  whatIsSolidayEuroFooter,
])

.component('whatIsSolidaryEuro', whatIsSolidaryEuroComponent)

.name;

export default whatIsSolidaryEuroModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryEuro.js